export default __webpack_public_path__ + "static/media/box1_step4.bb04e779.png";